import { Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { AdminDashboard } from './Admin';
import { Outlet } from 'react-router-dom';
// media query
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
export const Dashboard = () => {
    // media query
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const user = JSON.parse(localStorage.getItem('user'))
    useEffect(()=>{
        if(!user){
            window.location.href = '/'
        }
    },[])
    const [auth, setAuth] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);


    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const [openDrawer, setOpenDrawer] = useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpenDrawer(newOpen);
    };
    const handleLogout = () =>{
        localStorage.removeItem('user');
        window.location.href = '/'
    }
    return (
        <>
            {
                user
                ?
                <Box sx={{ flexGrow: 1 }}>
                    <AppBar position="static">
                        <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            onClick={toggleDrawer(true)}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            Tabulation System v1
                        </Typography>
                        {auth && (
                            <Box sx={{display:'flex',alignItems:'center',gap:1}}>
                            <Typography>{user&&(user.name)}</Typography>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                <MenuItem onClick={handleClose}>My account</MenuItem>
                            </Menu>
                            </Box>
                        )}
                        </Toolbar>
                    </AppBar>
                    {
                        user.role === 1
                        ?
                        <AdminDashboard openDrawer={openDrawer} toggleDrawer = {toggleDrawer}/>
                        :
                        null
                    }
                    <Box sx={{ py: 1,p:5}}>
                        <Outlet />
                    </Box>
                    </Box>
                :
                null
            }
        </>
        
    )
}